import { InstanceDashboardStack } from 'component/navigation/instance';

export default function RankingEvalSourcesLayout() {
    return <InstanceDashboardStack />;
}
